"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.subscribeToWarehouseMedicationsPrescriptionConsumptionOperationItems = exports.deleteItemRealTime = exports.editItemRealTime = exports.addItemRealTime = exports.editWarehouseMedicationsPrescriptionConsumptionOperationItem = exports.deleteItem = exports.addWarehouseMedicationsPrescriptionConsumptionOperationItem = exports.fetchItemById = exports.fetchMedicationsItemsByOperationId = exports.fetchWarehouseMedicationsPrescriptionConsumptionOperationItemsByDate = exports.fetchItemsInBatches = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var supabaseClient_1 = require("../../supabaseClient"); // Adjust the import path as needed
var initialState = {
    data: [],
    status: "idle",
    error: null,
    globalData: {},
    loaded: false,
};
// Fetch all items
exports.fetchItemsInBatches = (0, toolkit_1.createAsyncThunk)("warehouseMedicationsPrescriptionConsumptionOperationItems/fetchItemsInBatches", function (_, _a) {
    var rejectWithValue = _a.rejectWithValue;
    return __awaiter(void 0, void 0, void 0, function () {
        var _b, data, error;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, supabaseClient_1.supabase
                        .from("warehouseMedicationsPrescriptionConsumptionOperationItems")
                        .select("*")];
                case 1:
                    _b = _c.sent(), data = _b.data, error = _b.error;
                    if (error) {
                        return [2 /*return*/, rejectWithValue(error.message)];
                    }
                    return [2 /*return*/, data];
            }
        });
    });
});
exports.fetchWarehouseMedicationsPrescriptionConsumptionOperationItemsByDate = (0, toolkit_1.createAsyncThunk)("warehouseMedicationsPrescriptionConsumptionOperationItems/fetchWarehouseMedicationsPrescriptionConsumptionOperationItemsByDate", function (_a, _b) {
    var warehouseId = _a.warehouseId, gt = _a.gt, ls = _a.ls, byField = _a.byField;
    var rejectWithValue = _b.rejectWithValue;
    return __awaiter(void 0, void 0, void 0, function () {
        var _c, data, error;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0: return [4 /*yield*/, supabaseClient_1.supabase
                        .from("warehouseMedicationsPrescriptionConsumptionOperationItems")
                        .select("*")
                        .eq("warehouseId", warehouseId)
                        .gt(byField, gt)
                        .lt(byField, ls)];
                case 1:
                    _c = _d.sent(), data = _c.data, error = _c.error;
                    if (error) {
                        return [2 /*return*/, rejectWithValue(error.message)];
                    }
                    return [2 /*return*/, data];
            }
        });
    });
});
// Fetch items by operation ID
exports.fetchMedicationsItemsByOperationId = (0, toolkit_1.createAsyncThunk)("warehouseMedicationsPrescriptionConsumptionOperationItems/fetchMedicationsItemsByOperationId", function (warehouseMedicationsPrescriptionConsumptionOperationId, _a) {
    var rejectWithValue = _a.rejectWithValue;
    return __awaiter(void 0, void 0, void 0, function () {
        var _b, data, error;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, supabaseClient_1.supabase
                        .from("warehouseMedicationsPrescriptionConsumptionOperationItems")
                        .select("*")
                        .eq("warehouseMedicationsPrescriptionConsumptionOperationId", warehouseMedicationsPrescriptionConsumptionOperationId)];
                case 1:
                    _b = _c.sent(), data = _b.data, error = _b.error;
                    if (error) {
                        return [2 /*return*/, rejectWithValue(error.message)];
                    }
                    return [2 /*return*/, data];
            }
        });
    });
});
// Fetch item by ID
exports.fetchItemById = (0, toolkit_1.createAsyncThunk)("warehouseMedicationsPrescriptionConsumptionOperationItems/fetchItemById", function (itemId, _a) {
    var rejectWithValue = _a.rejectWithValue;
    return __awaiter(void 0, void 0, void 0, function () {
        var _b, data, error;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, supabaseClient_1.supabase
                        .from("warehouseMedicationsPrescriptionConsumptionOperationItems")
                        .select("*")
                        .eq("id", itemId)
                        .single()];
                case 1:
                    _b = _c.sent(), data = _b.data, error = _b.error;
                    if (error) {
                        return [2 /*return*/, rejectWithValue(error.message)];
                    }
                    return [2 /*return*/, data];
            }
        });
    });
});
// Add a new item
exports.addWarehouseMedicationsPrescriptionConsumptionOperationItem = (0, toolkit_1.createAsyncThunk)("warehouseMedicationsPrescriptionConsumptionOperationItems/addWarehouseMedicationsPrescriptionConsumptionOperationItem", function (newItem, thunkApi) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, insertData, insertError;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, supabaseClient_1.supabase
                    .from("warehouseMedicationsPrescriptionConsumptionOperationItems")
                    .insert(newItem)
                    .select()
                    .single()];
            case 1:
                _a = _b.sent(), insertData = _a.data, insertError = _a.error;
                if (insertError) {
                    return [2 /*return*/, thunkApi.rejectWithValue(insertError.message)];
                }
                return [2 /*return*/, insertData];
        }
    });
}); });
// Delete an item
exports.deleteItem = (0, toolkit_1.createAsyncThunk)("warehouseMedicationsPrescriptionConsumptionOperationItems/deleteItem", function (id, thunkApi) { return __awaiter(void 0, void 0, void 0, function () {
    var error;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, supabaseClient_1.supabase
                    .from("warehouseMedicationsPrescriptionConsumptionOperationItems")
                    .delete()
                    .eq("id", id)];
            case 1:
                error = (_a.sent()).error;
                if (error) {
                    return [2 /*return*/, thunkApi.rejectWithValue(error.message)];
                }
                return [2 /*return*/, id];
        }
    });
}); });
// Edit an item
exports.editWarehouseMedicationsPrescriptionConsumptionOperationItem = (0, toolkit_1.createAsyncThunk)("warehouseMedicationsPrescriptionConsumptionOperationItems/editWarehouseMedicationsPrescriptionConsumptionOperationItem", function (updatedItem, thunkApi) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, updateData, updateError;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, supabaseClient_1.supabase
                    .from("warehouseMedicationsPrescriptionConsumptionOperationItems")
                    .update(updatedItem)
                    .eq("id", updatedItem.id)
                    .select()
                    .single()];
            case 1:
                _a = _b.sent(), updateData = _a.data, updateError = _a.error;
                if (updateError) {
                    return [2 /*return*/, thunkApi.rejectWithValue(updateError.message)];
                }
                return [2 /*return*/, updateData];
        }
    });
}); });
// Real-time actions
var addItemRealTime = function (newItem) { return ({
    type: "warehouseMedicationsPrescriptionConsumptionOperationItems/addItemRealTime",
    payload: newItem,
}); };
exports.addItemRealTime = addItemRealTime;
var editItemRealTime = function (updatedItem) { return ({
    type: "warehouseMedicationsPrescriptionConsumptionOperationItems/editItemRealTime",
    payload: updatedItem,
}); };
exports.editItemRealTime = editItemRealTime;
var deleteItemRealTime = function (id) { return ({
    type: "warehouseMedicationsPrescriptionConsumptionOperationItems/deleteItemRealTime",
    payload: id,
}); };
exports.deleteItemRealTime = deleteItemRealTime;
// Slice definition
var warehouseMedicationsPrescriptionConsumptionOperationItemsSlice = (0, toolkit_1.createSlice)({
    name: "warehouseMedicationsPrescriptionConsumptionOperationItems",
    initialState: initialState,
    reducers: {
        addItemRealTime: function (state, action) {
            var exists = state.data.some(function (item) { return item.id === action.payload.id; });
            if (!exists) {
                state.data.push(action.payload);
            }
            state.error = null;
        },
        editItemRealTime: function (state, action) {
            var index = state.data.findIndex(function (item) { return item.id === action.payload.id; });
            if (index !== -1) {
                var isDifferent = JSON.stringify(state.data[index]) !==
                    JSON.stringify(action.payload);
                if (isDifferent) {
                    state.data[index] = action.payload;
                }
            }
            state.error = null;
        },
        deleteItemRealTime: function (state, action) {
            state.data = state.data.filter(function (item) { return item.id !== action.payload; });
            state.error = null;
        },
    },
    extraReducers: function (builder) {
        builder
            // Fetch all items
            .addCase(exports.fetchItemsInBatches.pending, function (state) {
            state.status = "loading";
        })
            .addCase(exports.fetchItemsInBatches.fulfilled, function (state, action) {
            state.loaded = true;
            state.data = action.payload;
            action.payload.forEach(function (item) {
                var _a;
                state.globalData[(_a = item.id) !== null && _a !== void 0 ? _a : ""] = item;
            });
            state.status = "succeeded";
        })
            .addCase(exports.fetchItemsInBatches.rejected, function (state, action) {
            state.status = "failed";
            state.error = action.payload || "Failed to fetch items.";
        })
            // Fetch all items
            .addCase(exports.fetchWarehouseMedicationsPrescriptionConsumptionOperationItemsByDate.pending, function (state) {
            state.status = "loading";
        })
            .addCase(exports.fetchWarehouseMedicationsPrescriptionConsumptionOperationItemsByDate.fulfilled, function (state, action) {
            state.loaded = true;
            state.data = action.payload;
            state.status = "succeeded";
        })
            .addCase(exports.fetchWarehouseMedicationsPrescriptionConsumptionOperationItemsByDate.rejected, function (state, action) {
            state.status = "failed";
            state.error =
                action.payload || "Failed to fetch items.";
        })
            // Fetch all items
            .addCase(exports.fetchMedicationsItemsByOperationId.pending, function (state) {
            state.status = "loading";
        })
            .addCase(exports.fetchMedicationsItemsByOperationId.fulfilled, function (state, action) {
            state.loaded = true;
            state.data = action.payload;
            state.status = "succeeded";
        })
            .addCase(exports.fetchMedicationsItemsByOperationId.rejected, function (state, action) {
            state.status = "failed";
            state.error =
                action.payload || "Failed to fetch items.";
        })
            // Fetch item by ID
            .addCase(exports.fetchItemById.pending, function (state) {
            state.status = "loading";
        })
            .addCase(exports.fetchItemById.fulfilled, function (state, action) {
            state.loaded = true;
            state.data = [action.payload];
            state.status = "succeeded";
        })
            .addCase(exports.fetchItemById.rejected, function (state, action) {
            state.status = "failed";
            state.error = action.payload || "Failed to fetch item.";
        })
            // Handle addItem
            .addCase(exports.addWarehouseMedicationsPrescriptionConsumptionOperationItem.fulfilled, function (state, action) {
            state.data.push(action.payload);
            state.error = null;
        })
            .addCase(exports.addWarehouseMedicationsPrescriptionConsumptionOperationItem.rejected, function (state, action) {
            state.error = action.payload || "Failed to add item.";
        })
            // Handle deleteItem
            .addCase(exports.deleteItem.fulfilled, function (state, action) {
            state.data = state.data.filter(function (item) { return item.id !== action.payload; });
            state.error = null;
        })
            .addCase(exports.deleteItem.rejected, function (state, action) {
            state.error = action.payload || "Failed to delete item.";
        })
            // Handle editItem
            .addCase(exports.editWarehouseMedicationsPrescriptionConsumptionOperationItem.fulfilled, function (state, action) {
            var index = state.data.findIndex(function (item) { return item.id === action.payload.id; });
            if (index !== -1) {
                state.data[index] = action.payload;
            }
            state.error = null;
        })
            .addCase(exports.editWarehouseMedicationsPrescriptionConsumptionOperationItem.rejected, function (state, action) {
            state.error = action.payload || "Failed to edit item.";
        });
    },
});
// Real-time subscription function
var subscribeToWarehouseMedicationsPrescriptionConsumptionOperationItems = function (dispatch, warehouseId) {
    var subscription = supabaseClient_1.supabase
        .channel("public:warehouseMedicationsPrescriptionConsumptionOperationItems")
        .on("postgres_changes", {
        event: "*",
        schema: "public",
        table: "warehouseMedicationsPrescriptionConsumptionOperationItems",
        filter: "warehouseId=eq.".concat(warehouseId),
    }, function (payload) {
        var _a;
        var newRecord = payload.new;
        var oldRecord = payload.old;
        switch (payload.eventType) {
            case "INSERT":
                dispatch((0, exports.addItemRealTime)(newRecord));
                break;
            case "UPDATE":
                dispatch((0, exports.editItemRealTime)(newRecord));
                break;
            case "DELETE":
                dispatch((0, exports.deleteItemRealTime)((_a = oldRecord.id) !== null && _a !== void 0 ? _a : ""));
                break;
            default:
                break;
        }
    })
        .subscribe();
    return function () {
        subscription.unsubscribe();
    };
};
exports.subscribeToWarehouseMedicationsPrescriptionConsumptionOperationItems = subscribeToWarehouseMedicationsPrescriptionConsumptionOperationItems;
exports.default = warehouseMedicationsPrescriptionConsumptionOperationItemsSlice.reducer;
